import { computed, Directive, inject, input } from '@angular/core';
import { DragDropService } from './drag-drop.service';

/** Enables dragging of attached element */
@Directive({
  selector: '[coinDrag]',
  standalone: false,
  host: {
    '[style.cursor]': `cursor()`,
    '[attr.draggable]': `isDraggable()`,
    '(dragstart)': 'startDragging($event)'
  }
})
export class DragDirective {
  private dragDropService = inject(DragDropService);

  /** Item (data) that should be dragged with the element */
  dragItem = input.required<unknown>({ alias: 'coinDrag' });
  dragDisabled = input(false);
  /** Preview element that is displayed during dragging. (Useful for e.g. drag handles) If not provided, uses the attached element.  */
  dragPreview = input<HTMLElement>();

  cursor = computed(() => {
    return this.dragDisabled() ? '' : 'move';
  });
  isDraggable = computed(() => {
    return this.dragDisabled() ? '' : 'true';
  });

  public startDragging(e: DragEvent): void {
    if (this.dragPreview()) {
      e.dataTransfer.setDragImage(this.dragPreview(), 0, 0);
    }

    this.dragDropService.startDragging(this.dragItem());
  }
}
